var _circle, _g, _circle2, _circle3, _g2, _circle4, _circle5, _g3, _path, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    fill: "white",
    fillOpacity: 0.07,
    stroke: "url(#paint0_radial_0_234)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_234)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_0_234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.9,
    stroke: "url(#paint1_radial_0_234)",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 35,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 17.5,
    fill: "url(#paint2_linear_0_234)",
    fillOpacity: 0.68
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 17.4,
    stroke: "url(#paint3_radial_0_234)",
    strokeOpacity: 0.7,
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_234)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 6,
    fill: "url(#paint4_linear_0_234)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 35,
    r: 5.9,
    stroke: "url(#paint5_radial_0_234)",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 35,
    height: 35
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.5,
    fill: "url(#paint6_linear_0_234)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 17.4,
    stroke: "url(#paint7_radial_0_234)",
    strokeOpacity: 0.76,
    strokeWidth: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_234)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 29,
    r: 6,
    fill: "url(#paint8_linear_0_234)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 29,
    r: 5.9,
    stroke: "url(#paint9_radial_0_234)",
    strokeWidth: 0.2
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5066 35.166C20.3329 35.166 18.5723 33.6809 18.5723 31.8473V21.891C18.5723 20.0574 20.3329 18.5723 22.5066 18.5723C24.6803 18.5723 26.4409 20.0574 26.4409 21.891V31.8473C26.4409 33.6809 24.6803 35.166 22.5066 35.166Z",
    fill: "url(#paint10_linear_0_234)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_0_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9994 31.4294C33.0523 31.4294 32.2852 30.8157 32.2852 30.058V25.9437C32.2852 25.186 33.0523 24.5723 33.9994 24.5723C34.9466 24.5723 35.7137 25.186 35.7137 25.9437V30.058C35.7137 30.8157 34.9466 31.4294 33.9994 31.4294Z",
    fill: "url(#paint11_linear_0_234)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_0_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6723 16.0361C25.5116 15.988 25.3405 15.988 25.1798 16.0361L16.6107 18.6076C16.2482 18.7163 16 19.0501 16 19.4286V30.1176C16 32.8273 17.4214 35.3383 19.7443 36.7325L24.9852 39.8779C25.2565 40.0407 25.5955 40.0407 25.8669 39.8779L31.1077 36.7325C32.2415 36.0521 33.1604 35.1057 33.8041 34H30.7753C27.4219 34 24.9565 30.2821 27.0119 27.1705L30.2317 22.2957C31.2934 20.6884 33.1523 20.0451 34.8521 20.3657V19.4286C34.8521 19.0501 34.6039 18.7163 34.2414 18.6076L25.6723 16.0361Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6723 16.0361C25.5116 15.988 25.3405 15.988 25.1798 16.0361L16.6107 18.6076C16.2482 18.7163 16 19.0501 16 19.4286V30.1176C16 32.8273 17.4214 35.3383 19.7443 36.7325L24.9852 39.8779C25.2565 40.0407 25.5955 40.0407 25.8669 39.8779L31.1077 36.7325C32.2415 36.0521 33.1604 35.1057 33.8041 34H30.7753C27.4219 34 24.9565 30.2821 27.0119 27.1705L30.2317 22.2957C31.2934 20.6884 33.1523 20.0451 34.8521 20.3657V19.4286C34.8521 19.0501 34.6039 18.7163 34.2414 18.6076L25.6723 16.0361Z",
    fill: "url(#paint12_linear_0_234)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5379 34.15C32.9161 35.1375 32.0644 35.9834 31.0306 36.6039L31.1077 36.7325L31.0306 36.6039L25.7897 39.7492C25.5659 39.8836 25.2862 39.8836 25.0624 39.7492L19.8215 36.6039C17.5437 35.2368 16.15 32.7746 16.15 30.1176V19.4286C16.15 19.1163 16.3548 18.841 16.6538 18.7512L25.2229 16.1798C25.3554 16.1401 25.4966 16.1401 25.6291 16.1798L34.1983 18.7512C34.4973 18.841 34.7021 19.1163 34.7021 19.4286V20.1883C32.9975 19.9333 31.1674 20.6069 30.1066 22.213L30.2317 22.2957L30.1066 22.213L26.8867 27.0878C24.7563 30.313 27.3194 34.15 30.7753 34.15H33.5379Z",
    stroke: "url(#paint13_linear_0_234)",
    strokeOpacity: 0.1,
    strokeWidth: 0.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_0_234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6615 23.2406C32.7542 21.5865 35.236 21.5865 36.3286 23.2406L39.5484 28.1154C40.77 29.9648 39.352 32.2857 37.215 32.2857H30.7752C28.6381 32.2857 27.2201 29.9648 28.4417 28.1154L31.6615 23.2406ZM34.852 25.4286C34.852 24.9552 34.4683 24.5714 33.9951 24.5714C33.5218 24.5714 33.1381 24.9552 33.1381 25.4286V26.2857C33.1381 26.7591 33.5218 27.1429 33.9951 27.1429C34.4683 27.1429 34.852 26.7591 34.852 26.2857V25.4286ZM34.852 28.8571C34.852 29.3305 34.4683 29.7143 33.9951 29.7143C33.5218 29.7143 33.1381 29.3305 33.1381 28.8571C33.1381 28.3837 33.5218 28 33.9951 28C34.4683 28 34.852 28.3837 34.852 28.8571Z",
    fill: "white",
    fillOpacity: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_234",
    x: -10,
    y: -10,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_234",
    x: 16,
    y: 19,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_0_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_234",
    x: -8.7,
    y: 3.3,
    width: 51.4,
    height: 51.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.85,
    result: "effect1_foregroundBlur_0_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_234",
    x: 27.8852,
    y: 20.1723,
    width: 12.2286,
    height: 15.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2,
    result: "effect1_foregroundBlur_0_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_0_234",
    x: 10,
    y: 10,
    width: 30.8521,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_234",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_0_234"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_0_234",
    x: 27.9902,
    y: 22,
    width: 12.0096,
    height: 11.8858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_234"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.503706 1.66611) rotate(44.0741) scale(76.0495 121.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_234",
    x1: 17,
    y1: 34.5,
    x2: 52,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3148 18.0413) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_234",
    x1: 26,
    y1: 35,
    x2: 38,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1079 29.357) rotate(44.0741) scale(16.2963 26.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_234",
    x1: 6,
    y1: 21.5,
    x2: 41,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBED96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABECD6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.31482 5.04132) rotate(44.0741) scale(47.5309 76.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_234",
    x1: 11,
    y1: 29,
    x2: 23,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_0_234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1079 23.357) rotate(44.0741) scale(16.2963 26.0636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_234",
    x1: 18.5723,
    y1: 18.5723,
    x2: 28.2979,
    y2: 19.7433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_234",
    x1: 32.2852,
    y1: 24.5723,
    x2: 36.5161,
    y2: 25.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#7523FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_234",
    x1: 16,
    y1: 16,
    x2: 38.7346,
    y2: 20.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_234",
    x1: 16.5891,
    y1: 17.0909,
    x2: 34.8521,
    y2: 17.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline5);
export default __webpack_public_path__ + "static/media/IconTimeline5.4150f4011f206ef855c19e60feb9c4bc.svg";
export { ForwardRef as ReactComponent };